export default __webpack_public_path__ + "static/media/vf-updated.dda81bbd.svg";